import React from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";

const StatusCell = ({ row }) => {
  const status = row.original.approve;
  const getStatusLabel = () =>
    // status === "1" ? "Accepted" : status === "2" ? "Rejected" : "Pending";
    status === "Accepted" ? "Accepted" : status === "Rejected" ? "Rejected" : "Pending";

  const getColor = () => {
    if (status === "Accepted") return "#4caf50";
    if (status === "Rejected") return "#f44336";
    return "#ff9800";
  };

  return (
    <Chip
      label={getStatusLabel()}
      size="small"
      sx={{
        backgroundColor: getColor(),
        color: "white",
        fontWeight: "bold",
        textTransform: "capitalize",
      }}
    />
  );
};

StatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      approve: PropTypes.string,
    }),
  }),
};

export default StatusCell;
